import { render, staticRenderFns } from "./SafeDigMyCourses.vue?vue&type=template&id=38327a9c&scoped=true"
import script from "./SafeDigMyCourses.vue?vue&type=script&lang=js"
export * from "./SafeDigMyCourses.vue?vue&type=script&lang=js"
import style0 from "./SafeDigMyCourses.vue?vue&type=style&index=0&id=38327a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38327a9c",
  null
  
)

export default component.exports